import { Route } from 'react-router-dom';
import SchedulePage from './components/Schedule.page';
import CarePlanPage from '../../components/pageComponents/CarePlan.page';
import EditProfilePage from '../../components/pageComponents/EditProfile.page';
import { AppointmentList } from 'src/pages/appointment';

export const getCareConnectRoutes = () => {
  const pages = [
    {
      path: '/schedule/:id',
      Component: SchedulePage,
    },
    {
      path: '/appointments',
      Component: AppointmentList,
    },
    {
      path: '/careplan',
      Component: CarePlanPage,
    },
    {
      path: '/editprofile',
      Component: EditProfilePage,
    },
  ];

  return pages.map((route) => {
    const { path, Component } = route;
    return <Route key={path} path={path} element={<Component />} />;
  });
};
